module.exports = "https://cdn2-fs.clearscore.com/flux/images/848f4b513db4968673437415cb035b38.jpg";